import React, { PropsWithChildren } from 'react'
import { logException } from '@babylon/sentry'
import { trackTealiumEvent } from '@/tracking'

interface Props {
  Component?: React.ComponentType
}

type ErrorBoundryProps = PropsWithChildren<Props>
type ErrorBoundryState = {
  hasError: boolean
}

class ErrorBoundary extends React.Component<
  ErrorBoundryProps,
  ErrorBoundryState
> {
  constructor(props: ErrorBoundryProps) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error: Error) {
    this.setState({ hasError: true })

    logException(error)

    trackTealiumEvent({
      eventAction: 'Error',
      eventCategory: 'ErrorBoundary',
      screen_title: window.location.pathname,
      eventLabel: error?.message,
      tealium_event: 'Error',
    })
  }

  render() {
    const { children, Component } = this.props
    const { hasError } = this.state

    if (hasError) {
      if (Component) {
        return <Component />
      }

      return <h2>Something went wrong.</h2>
    }

    return children
  }
}

export default ErrorBoundary
